/* src/App.js - v13.23 - Wallpaper Visibility Fix */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import './App.css';

import AdminDashboard from './components/AdminDashboard';
import Sidebar from './components/Sidebar';
import Feed from './components/Feed';
import Widgets from './components/Widgets';
import Profile from './components/Profile';
import Groups from './components/Groups';      
import Messages from './components/Messages'; 
import Login from './components/Login'; 
import ResetPassword from './components/ResetPassword'; 
import GroupDetails from './components/GroupDetails'; 
import DraggableFeedback from './components/DraggableFeedback';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';

import MENU_ITEMS from './menuConfig.json';

const API_URL = '/api/posts';
const NOTIFICATION_SOUND = 'data:audio/mp3;base64,//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq//uQxAAAAANIAAAAAExBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq';

const wallpapers = [ 
  "/backgrounds/background1.jpg", "/backgrounds/background2.jpg", "/backgrounds/background3.jpg", 
  "/backgrounds/background4.jpg", "/backgrounds/background5.jpg", "/backgrounds/background6.jpg", 
  "/backgrounds/background7.jpg", "/backgrounds/background8.jpg", "/backgrounds/background9.jpg", 
  "/backgrounds/background10.jpg", "/backgrounds/background11.jpg", "/backgrounds/background12.jpg", 
  "/backgrounds/background13.jpg" 
];

const getSafeImage = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    if (path.startsWith('/')) return path;
    return `/${path}`;
};

const GUEST_USER_OBJ = {
    name: 'Guest',
    username: 'guest',
    avatarColor: '#555',
    profile_pic: null,
    isGuest: true
};

const PageTitle = ({ title }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return null;
};

function App() {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('nsn_user');
    if (savedUser) {
        const u = JSON.parse(savedUser);
        if (!u.name && u.username) u.name = u.username;
        return u;
    }
    return null;
  });

  const [showLoginModal, setShowLoginModal] = useState(false); 
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [dontShowWelcomeAgain, setDontShowWelcomeAgain] = useState(false);
  const [welcomeConfig, setWelcomeConfig] = useState(null); 

  const [view, setView] = useState(() => localStorage.getItem('nsn_view') || 'home');
  const [currentGroupSlug, setCurrentGroupSlug] = useState(() => localStorage.getItem('nsn_group_slug') || null);
  
  const [currentPostId, setCurrentPostId] = useState(null);
  const [viewedUser, setViewedUser] = useState(null); 
  const [searchTag, setSearchTag] = useState(null); 
  const [profileParams, setProfileParams] = useState(null); 
  const [messagesTab, setMessagesTab] = useState('chats');
  const [feedbackPrompt, setFeedbackPrompt] = useState(null); 
  const [chatTarget, setChatTarget] = useState(null);

  const [showSearchModal, setShowSearchModal] = useState(false);
  const [globalSearchTerm, setGlobalSearchTerm] = useState('');
  const [globalSearchResults, setGlobalSearchResults] = useState({ users: [], posts: [], groups: [] });
  const [isSearching, setIsSearching] = useState(false); 
  
  const [notifications, setNotifications] = useState([]);
  const [showNotifModal, setShowNotifModal] = useState(false);
  const [totalUnread, setTotalUnread] = useState(0);
  const [aiUnread, setAiUnread] = useState(0); 
  
  const audioRef = useRef(new Audio(NOTIFICATION_SOUND));
  const lastUnreadCountRef = useRef(0); 
  const mainContentRef = useRef(null);
  const [showBottomNav, setShowBottomNav] = useState(true);
  const touchStartRef = useRef(null); 

  // --- HOTFIX: FORCE MOBILE DARK MODE ---
  useEffect(() => {
      let metaThemeColor = document.querySelector("meta[name=theme-color]");
      if (!metaThemeColor) {
          metaThemeColor = document.createElement("meta");
          metaThemeColor.name = "theme-color";
          document.head.appendChild(metaThemeColor);
      }
      metaThemeColor.content = "#1e1e24"; 
      document.body.style.backgroundColor = "#1e1e24";
  }, []);

  useEffect(() => {
      fetch('/api/config/public')
        .then(res => res.json())
        .then(data => {
            setWelcomeConfig(data);
            const hasSeenWelcome = localStorage.getItem('nsn_welcome_seen');
            if (!user && !hasSeenWelcome && data.welcome_title) {
                setTimeout(() => setShowWelcomeModal(true), 500);
            }
        })
        .catch(err => console.error("Config fetch error:", err));
  }, [user]);

  const handleCloseWelcome = () => {
      if (dontShowWelcomeAgain) {
          localStorage.setItem('nsn_welcome_seen', 'true');
      }
      setShowWelcomeModal(false);
  };

  useEffect(() => {
      localStorage.setItem('nsn_view', view);
      if (currentGroupSlug) localStorage.setItem('nsn_group_slug', currentGroupSlug);
      else localStorage.removeItem('nsn_group_slug');
  }, [view, currentGroupSlug]);

  useEffect(() => {
      const path = window.location.pathname;
      if (path.startsWith('/post/')) {
          const pid = parseInt(path.split('/')[2]);
          if (pid) { setCurrentPostId(pid); setView('post_details'); }
      }
  }, []);

  useEffect(() => {
      if (user) {
          const lookupName = user.name || user.username;
          fetch(`/api/user/public/${lookupName}`).then(res => res.json()).then(data => {
                if (data && (data.name || data.username)) {
                    const freshUser = { ...user, ...data };
                    if (!freshUser.name && freshUser.username) freshUser.name = freshUser.username;
                    if (JSON.stringify(freshUser) !== JSON.stringify(user)) {
                        setUser(freshUser);
                        localStorage.setItem('nsn_user', JSON.stringify(freshUser));
                    }
                }
            }).catch(e => console.error("User refresh failed", e));
      }
  }, [user]);

  useEffect(() => {
      const delayDebounceFn = setTimeout(async () => {
        if (!globalSearchTerm.trim()) {
            setGlobalSearchResults({ users: [], posts: [], groups: [] });
            return;
        }
        setIsSearching(true);
        try {
            const res = await fetch(`/api/search?q=${encodeURIComponent(globalSearchTerm)}`);
            if (res.ok) {
                const data = await res.json();
                setGlobalSearchResults({
                    users: data.users || [],
                    posts: data.posts || [],
                    groups: data.groups || []
                });
            }
        } catch (e) { console.error("Search failed", e); } finally { setIsSearching(false); }
      }, 500); 
      return () => clearTimeout(delayDebounceFn);
  }, [globalSearchTerm]);

  const handleLogin = (userData) => {
    if (userData.profile_pic) userData.profile_pic = getSafeImage(userData.profile_pic);
    if (!userData.name && userData.username) userData.name = userData.username;
    setUser(userData);
    setShowLoginModal(false); 
    localStorage.setItem('nsn_user', JSON.stringify(userData));
  };

  const handleLogout = () => { 
      localStorage.clear(); 
      window.location.href = '/'; 
  };

  const [backgroundStyle, setBackgroundStyle] = useState({
      backgroundColor: '#1e1e24', 
      backgroundImage: `linear-gradient(rgba(13, 13, 18, 0.75), rgba(13, 13, 18, 0.85))` 
  });
  
  const [posts, setPosts] = useState([]);

  const fetchPosts = useCallback(async () => {
    try {
      const baseUrl = user ? `${API_URL}?current_user=${user.name}` : API_URL;
      const url = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}t=${new Date().getTime()}`; 
      const response = await fetch(url);
      if (response.ok) { const data = await response.json(); setPosts(Array.isArray(data) ? data : []); }
    } catch (error) { console.error(error); setPosts([]); }
  }, [user]);

  useEffect(() => { 
      fetchPosts(); 
      const interval = setInterval(fetchPosts, 30000); 
      return () => clearInterval(interval); 
  }, [fetchPosts]);

  useEffect(() => {
    const randomImage = wallpapers[Math.floor(Math.random() * wallpapers.length)];
    setBackgroundStyle({ 
        backgroundColor: '#1e1e24',
        backgroundImage: `linear-gradient(rgba(13, 13, 18, 0.75), rgba(13, 13, 18, 0.85)), url(${randomImage})`, 
        backgroundSize: 'cover', 
        backgroundPosition: 'center' 
    });
  }, []);

  useEffect(() => {
    if (!user) return;
    
    const fetchNotifications = async () => {
        try {
            const res = await fetch(`/api/notifications?user=${user.name}`);
            if (res.ok) {
                const data = await res.json();
                setNotifications(data);
            }
        } catch (e) {}
    };
    
    const checkUnread = async () => {
        try {
            const res = await fetch(`/api/messages/unread-count?user=${user.name}`);
            const data = await res.json();
            
            const regularCount = data.count || 0;
            const nexusCount = data.ai_count || 0;
            const combined = regularCount + nexusCount;

            setTotalUnread(regularCount); 
            setAiUnread(nexusCount);      

            if (combined > lastUnreadCountRef.current) {
                try { audioRef.current.play().catch(e => {}); } catch(e){}
            }
            lastUnreadCountRef.current = combined;
        } catch (e) { }
    };

    fetchNotifications();
    checkUnread();
    
    const interval = setInterval(() => {
        fetchNotifications();
        checkUnread();
    }, 5000);
    
    return () => clearInterval(interval);
  }, [user]);

  const handleScrollTop = () => { setTimeout(() => { if (mainContentRef.current) mainContentRef.current.scrollTop = 0; window.scrollTo(0, 0); }, 50); };
  
  const handleMenuTouchStart = (e) => { touchStartRef.current = e.targetTouches[0].clientY; };
  const handleMenuTouchMove = (e) => {
      if (!touchStartRef.current) return;
      if (e.targetTouches[0].clientY - touchStartRef.current > 10) { setShowBottomNav(false); touchStartRef.current = null; }
  };

  const handleHardRefresh = () => { window.location.reload(); };

  const handleGoHome = () => { setSearchTag(null); fetchPosts(); setView('home'); handleScrollTop(); };
  const handleSearchTag = (tag) => { setSearchTag(tag); setView('home'); handleScrollTop(); };
  const handleNavigatePost = (postId) => { setCurrentPostId(postId); setView('post_details'); handleScrollTop(); };
  const handleNavigateGroup = (slug) => { setCurrentGroupSlug(slug); setView('group_details'); handleScrollTop(); };
  
  const handleNavigateProfile = async (targetName) => {
      setProfileParams(null); setShowSearchModal(false);
      if (user && targetName === user.name) { setViewedUser(null); setView('profile'); } 
      else { const res = await fetch(`/api/user/public/${targetName}`); const data = await res.json(); if (res.ok) { if (!data.name && data.username) data.name = data.username; setViewedUser(data); setView('profile'); } }
      handleScrollTop();
  };

  const handleNavigateGallery = async (targetName, photoId) => {
      if (user && targetName !== user.name) {
          const res = await fetch(`/api/user/public/${targetName}`);
          const data = await res.json();
          if (res.ok) { if (!data.name && data.username) data.name = data.username; setViewedUser(data); setView('profile'); }
      } else if (!user) {
          const res = await fetch(`/api/user/public/${targetName}`);
          const data = await res.json();
          if (res.ok) { if (!data.name && data.username) data.name = data.username; setViewedUser(data); }
      } else { setViewedUser(null); }
      setProfileParams({ tab: 'gallery', photoId: photoId }); setView('profile'); handleScrollTop();
  };

  const handleStartAIChat = () => {
      setMessagesTab('ai');
      setView('messages');
      handleScrollTop();
  };

  const handleStartMessage = (targetUsername) => {
      setChatTarget(targetUsername);
      setMessagesTab('chats');
      setView('messages');
      handleScrollTop();
  };

  const handleSidebarNavigate = (viewName) => {
      if (!user && ['messages', 'profile', 'nexus'].includes(viewName)) {
          setShowLoginModal(true);
          return;
      }
      if (viewName === 'nexus') { setMessagesTab('ai'); setView('messages'); } 
      else { 
          if (viewName === 'messages') setMessagesTab('chats'); 
          if (viewName === 'profile') handleNavigateProfile(user.name); 
          else setView(viewName); 
      }
      handleScrollTop();
  };

  const handleFeedbackClick = () => { 
      if(!user) return alert("Please login to send feedback.");
      setMessagesTab('ai'); 
      setView('messages');  
      window.scrollTo(0,0); 
  };

  const handleLegalNavigate = (targetView) => {
      setView(targetView);
      window.scrollTo(0,0); 
  };

  const handleClearNotifications = async () => {
      await fetch('/api/notifications/clear-all', { 
          method: 'POST', 
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ username: user.name })
      });
      setNotifications([]);
      setShowNotifModal(false);
  };

  const handleAddPost = async (newPost) => { try { await fetch(API_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(newPost) }); fetchPosts(); } catch (error) { console.error(error); } };
  const handleDeletePost = async (id) => { try { await fetch(`${API_URL}/${id}`, { method: 'DELETE' }); fetchPosts(); } catch (error) { console.error(error); } };
  const handleLikeToggle = async (postId, voteType) => { try { await fetch(`${API_URL}/${postId}/like`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ username: user.name, vote: voteType }) }); fetchPosts(); } catch (error) { console.error(error); } };
  const handleAddComment = async (postId, text) => { try { await fetch(`${API_URL}/${postId}/comment`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ user: user.name, text }) }); fetchPosts(); } catch (error) { console.error(error); } };
  const handleDeleteComment = async (postId, commentId) => { try { await fetch(`${API_URL}/${postId}/comment/${commentId}`, { method: 'DELETE' }); fetchPosts(); } catch (error) { console.error(error); } };
  const handleEditComment = async (postId, commentId, text) => { try { await fetch(`${API_URL}/${postId}/comment/${commentId}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ text }) }); fetchPosts(); } catch (error) { console.error(error); } };
  
  const handleEditPost = async (postId, newText, newVisibility) => { 
      try { 
          await fetch(`${API_URL}/${postId}`, { 
              method: 'PUT', 
              headers: { 'Content-Type': 'application/json' }, 
              body: JSON.stringify({ message: newText, visibility: newVisibility }) 
          }); 
          fetchPosts(); 
      } catch (error) { console.error(error); } 
  };

  const triggerLogin = () => setShowLoginModal(true);

  const renderDynamicNav = () => {
    let activeLayout = user ? (user.menu_layout || MENU_ITEMS.map(i => i.id)) : ['home', 'groups', 'search'];
    
    if (user) {
        if (!activeLayout.includes('profile')) activeLayout = ['profile', ...activeLayout];
        if (!activeLayout.includes('home')) activeLayout = [...activeLayout, 'home'];
    }

    return activeLayout.map(id => {
        const item = MENU_ITEMS.find(i => i.id === id);
        if(!item) return null;
        let onClick = () => {};
        let content = <span style={{ fontSize: '24px' }}>{item.icon}</span>;
        let badge = null;

        switch(id) {
            case 'profile':
                onClick = () => user ? handleNavigateProfile(user.name) : triggerLogin();
                content = user && user.profile_pic ? 
                    <img src={getSafeImage(user.profile_pic)} style={{ width: '35px', height: '35px', borderRadius: '50%', objectFit: 'cover' }} alt="Profile" /> : 
                    <div style={{ width: '35px', height: '35px', borderRadius: '50%', background: activeUser.avatarColor }}></div>;
                break;
            case 'home':
                onClick = handleGoHome;
                content = <img src="/nubix.png" alt="Home" style={{ width: '35px', height: '35px', borderRadius: '50%', objectFit: 'cover' }} />;
                break;
            case 'messages':
                onClick = () => { 
                    if(!user) triggerLogin();
                    else { setView('messages'); setMessagesTab('chats'); }
                };
                if(user && totalUnread > 0) badge = <div style={{ position: 'absolute', top: '-5px', right: '-5px', background: '#ff4757', color: 'white', borderRadius: '50%', minWidth: '18px', height: '18px', fontSize: '11px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', border: '2px solid #2f3542', padding: '0 4px' }}>{totalUnread > 99 ? '99+' : totalUnread}</div>;
                break;
            case 'groups':
                onClick = () => setView('groups');
                break;
            case 'nexus':
                onClick = () => { 
                    if(!user) triggerLogin();
                    else { setMessagesTab('ai'); setView('messages'); }
                };
                break;
            case 'search':
                onClick = () => setShowSearchModal(true);
                break;
            default: return null;
        }

        return (
            <div key={id} className="bottom-nav-icon" onClick={onClick} style={{ position: 'relative' }}>
                {content}
                {badge}
            </div>
        );
    });
  };

  if (window.location.pathname === '/reset-password') return <ResetPassword onComplete={() => window.location.href = '/'} backgroundStyle={backgroundStyle} />;

  if (window.location.hostname.startsWith('a5d4m9i7n.')) {
      return <AdminDashboard adminUser={user ? user.name : null} />;
  }

  const homePosts = posts.filter(p => { if (p.group_slug) return false; if (searchTag) return p.message && p.message.toLowerCase().includes(searchTag); return true; });
  const activeUser = user || GUEST_USER_OBJ; 
  const unreadNotifs = notifications.filter(n => !n.read).length;

  return (
    <div className="app-container">
      <PageTitle 
        title={view === 'home' ? 'Nubix | Newsfeed' : 
                view === 'profile' ? `Nubix | ${viewedUser ? viewedUser.name : (user ? user.name : 'Profile')}` :
                'Nubix Social Network'} 
      />

      <div className="background-layer" style={backgroundStyle}></div>
      
      <Sidebar 
          onNavigate={handleSidebarNavigate} 
          onRefresh={handleGoHome} 
          onLogout={handleLogout} 
          user={activeUser} 
          messageCount={totalUnread}
          onSearch={setShowSearchModal}
      />
      
      <div className={`bottom-nav ${showBottomNav ? '' : 'hidden'}`} onTouchStart={handleMenuTouchStart} onTouchMove={handleMenuTouchMove}>
          {renderDynamicNav()}
      </div>
      
      <div className="main-content" ref={mainContentRef}>
        <div className="content-grid">
            <div className="feed-wrapper">
                {view === 'home' && (
                    <>
                        <div className="card" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'8px 20px', minHeight: '50px', position: 'relative', zIndex: 50 }}>
                            <h2 onClick={handleHardRefresh} style={{ margin:0, fontSize:'1.2rem', cursor: 'pointer' }}>
                                {searchTag ? (<span>Trending: <span style={{color:'#ff4757'}}>{searchTag}</span></span>) : 'Newsfeed'}
                            </h2>
                            <div style={{ display:'flex', gap:'15px', alignItems:'center' }}>
                                {user && (
                                    <div 
                                        onClick={() => setShowNotifModal(!showNotifModal)} 
                                        style={{ cursor: 'pointer', fontSize: '1.2rem', position: 'relative', marginRight: '5px' }}
                                    >
                                        🔔
                                        {unreadNotifs > 0 && <div style={{ position: 'absolute', top: '-5px', right: '-5px', background: '#ff4757', color: 'white', borderRadius: '50%', width: '16px', height: '16px', fontSize: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>{unreadNotifs}</div>}
                                        
                                        {showNotifModal && (
                                            <div onClick={(e) => e.stopPropagation()} style={{ position: 'absolute', top: '45px', right: '-10px', width: '300px', background: '#2f3542', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '12px', zIndex: 10000, boxShadow: '0 10px 40px rgba(0,0,0,0.5)', padding: '15px', cursor: 'default' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                                    <h4 style={{ margin: 0 }}>Notifications</h4>
                                                    <button onClick={handleClearNotifications} style={{ background: 'none', border: 'none', color: '#ff4757', cursor: 'pointer', fontSize: '0.8rem' }}>Clear All</button>
                                                </div>
                                                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                    {notifications.length === 0 && <div style={{ color: '#aaa', fontSize: '0.9rem', textAlign: 'center', padding: '20px' }}>No new notifications</div>}
                                                    {notifications.map(n => (<div key={n.id} style={{ padding: '10px', borderBottom: '1px solid rgba(255,255,255,0.05)', fontSize: '0.9rem', color: n.read ? '#aaa' : 'white' }}>{n.text}</div>))}
                                                </div>
                                                <button onClick={() => setShowNotifModal(false)} style={{ width: '100%', marginTop: '10px', padding: '5px', background: 'rgba(255,255,255,0.1)', border: 'none', color: 'white', borderRadius: '5px', cursor: 'pointer' }}>Close</button>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {searchTag && (<button onClick={() => setSearchTag(null)} className="action-btn">Clear</button>)}
                                <div onClick={() => setShowSearchModal(true)} style={{ cursor: 'pointer', fontSize: '1.2rem', padding: '5px' }}>🔍</div>
                            </div>
                        </div>

                        <Feed 
                            user={user} 
                            posts={homePosts} 
                            onTriggerLogin={triggerLogin} 
                            onAddPost={handleAddPost} onDeletePost={handleDeletePost} onLikePost={handleLikeToggle} onAddComment={handleAddComment} onDeleteComment={handleDeleteComment} onEditComment={handleEditComment} onEdit={handleEditPost} onNavigateProfile={handleNavigateProfile}
                        />

                        <div className="mobile-footer" style={{ padding: '30px 20px', textAlign: 'center', color: '#666', fontSize: '0.85rem' }}>
                            <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <span onClick={() => handleLegalNavigate('terms')} style={{ cursor: 'pointer', textDecoration: 'underline' }}>Terms of Service</span>
                                <span onClick={() => handleLegalNavigate('privacy')} style={{ cursor: 'pointer', textDecoration: 'underline' }}>Privacy Policy</span>
                            </div>
                            <div>Nubix Social v1.0 • © 2026</div>
                        </div>
                    </>
                )}
                {view === 'groups' && <Groups user={user} onNavigateGroup={handleNavigateGroup} onTriggerLogin={triggerLogin} />}
                {view === 'group_details' && <GroupDetails groupSlug={currentGroupSlug} user={user} posts={posts} onTriggerLogin={triggerLogin} onNavigateProfile={handleNavigateProfile} onBack={() => setView('groups')} onAddPost={handleAddPost} onDeletePost={handleDeletePost} onLikePost={handleLikeToggle} onAddComment={handleAddComment} onDeleteComment={handleDeleteComment} onEditComment={handleEditComment} onEditPost={handleEditPost} />}
                {view === 'profile' && <Profile user={user} targetUser={viewedUser} posts={posts} onTriggerLogin={triggerLogin} onNavigate={setView} onLogout={handleLogout} onUpdateUser={handleLogin} onDeletePost={handleDeletePost} onLikePost={handleLikeToggle} onAddComment={handleAddComment} onDeleteComment={handleDeleteComment} onEditComment={handleEditComment} onEditPost={handleEditPost} initialParams={profileParams} onStartAIChat={handleStartAIChat} onStartMessage={handleStartMessage} onNavigatePost={handleNavigatePost} onSearchTag={handleSearchTag} />}
                {view === 'messages' && user && <Messages user={user} initialTab={messagesTab} initialMessage={feedbackPrompt} initialTarget={chatTarget} onClearInitial={() => setFeedbackPrompt(null)} onClearTarget={() => setChatTarget(null)} />}

                {view === 'terms' && <TermsOfService onBack={() => setView('home')} />}
                {view === 'privacy' && <PrivacyPolicy onBack={() => setView('home')} />}
                
                {view === 'post_details' && (
                    <div style={{ paddingBottom: '50px' }}>
                        <div className="card" style={{ marginBottom: '15px' }}>
                            <button onClick={handleGoHome} style={{ background: 'none', border: 'none', color: '#1e90ff', cursor: 'pointer', fontSize: '1rem', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                ⬅️ Back to Newsfeed
                            </button>
                        </div>
                        <Feed 
                            user={user} 
                            posts={posts.filter(p => p.id === currentPostId)} 
                            onTriggerLogin={triggerLogin} 
                            onAddPost={handleAddPost} onDeletePost={handleDeletePost} onLikePost={handleLikeToggle} onAddComment={handleAddComment} onDeleteComment={handleDeleteComment} onEditComment={handleEditComment} onEdit={handleEditPost} onNavigateProfile={handleNavigateProfile}
                        />
                    </div>
                )}
            </div>
            
            <div className="widgets-area">
                {user && (
                    <Widgets 
                        posts={posts} 
                        user={user} 
                        onNavigatePost={handleNavigatePost} 
                        onSearchTag={handleSearchTag} 
                        onNavigateGallery={handleNavigateGallery} 
                        onNavigate={handleLegalNavigate}
                    />
                )}
            </div>
        </div>
      </div>
      
      <DraggableFeedback onClick={handleFeedbackClick} unreadCount={aiUnread} />
      
      {showSearchModal && (
          <div onClick={() => setShowSearchModal(false)} style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(5px)', zIndex: 10000, display: 'flex', justifyContent: 'center', paddingTop: '80px' }}>
              <div onClick={(e) => e.stopPropagation()} className="card" style={{ width: '90%', maxWidth: '500px', height: 'fit-content', maxHeight: '70vh', display: 'flex', flexDirection: 'column', padding: '20px' }}>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '15px' }}>
                      <span style={{ fontSize: '1.2rem' }}>🔍</span>
                      <input autoFocus placeholder="Search..." style={{ flex: 1, background: 'transparent', border: 'none', color: 'white', fontSize: '1.1rem', outline: 'none' }} value={globalSearchTerm} onChange={(e) => setGlobalSearchTerm(e.target.value)} />
                      <button onClick={() => setShowSearchModal(false)} style={{ background: 'none', border: 'none', color: '#ccc', cursor: 'pointer' }}>✕</button>
                  </div>
                  <div style={{ overflowY: 'auto' }}>
                      {isSearching && <div style={{ color: '#2ed573', textAlign: 'center', padding: '20px' }}>⏳ Searching...</div>}
                      {!isSearching && (
                        <>
                            {globalSearchResults.users.length > 0 && (<div style={{ marginBottom: '15px' }}><div style={{ fontSize: '0.8rem', color: '#888', marginBottom: '5px', textTransform: 'uppercase' }}>People</div>{globalSearchResults.users.map(u => (<div key={u.name} onClick={() => handleNavigateProfile(u.name)} style={{ padding: '10px', display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', borderRadius: '8px', background: 'rgba(255,255,255,0.05)', marginBottom: '5px' }}><div style={{ width: '30px', height: '30px', borderRadius: '50%', background: u.avatarColor || '#555', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{u.name[0]}</div><div><div>{u.name}</div><div style={{ fontSize: '0.8rem', color: '#aaa' }}>{u.handle}</div></div></div>))}</div>)}
                            {globalSearchResults.groups.length > 0 && (<div style={{ marginBottom: '15px' }}><div style={{ fontSize: '0.8rem', color: '#888', marginBottom: '5px', textTransform: 'uppercase' }}>Communities</div>{globalSearchResults.groups.map(g => (<div key={g.id} onClick={() => { handleNavigateGroup(g.slug); setShowSearchModal(false); }} style={{ padding: '10px', cursor: 'pointer', borderRadius: '8px', background: 'rgba(255,255,255,0.05)', marginBottom: '5px' }}>👥 {g.name}</div>))}</div>)}
                            {globalSearchResults.posts.length > 0 && (<div><div style={{ fontSize: '0.8rem', color: '#888', marginBottom: '5px', textTransform: 'uppercase' }}>Posts</div>{globalSearchResults.posts.map(p => (<div key={p.id} onClick={() => handleNavigatePost(p.id)} style={{ padding: '10px', cursor: 'pointer', borderRadius: '8px', background: 'rgba(255,255,255,0.05)', marginBottom: '5px' }}><div style={{ fontSize: '0.9rem' }}>{p.message.substring(0, 50)}...</div><div style={{ fontSize: '0.75rem', color: '#aaa' }}>by {p.username}</div></div>))}</div>)}
                            {globalSearchTerm && !isSearching && !globalSearchResults.users.length && !globalSearchResults.posts.length && !globalSearchResults.groups.length && (<div style={{ textAlign: 'center', color: '#777', padding: '20px' }}>No results found.</div>)}
                        </>
                      )}
                  </div>
              </div>
          </div>
      )}

      {showLoginModal && (
          <Login onLogin={handleLogin} onClose={() => setShowLoginModal(false)} backgroundStyle={{}} />
      )}
      
      {showWelcomeModal && welcomeConfig && (
          <div onClick={handleCloseWelcome} style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(8px)', zIndex: 10001, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div onClick={(e) => e.stopPropagation()} className="card" style={{ width: '90%', maxWidth: '500px', padding: '30px', textAlign: 'center', border: '1px solid rgba(255,255,255,0.1)', position: 'relative' }}>
                  <h1 style={{ marginTop: 0, fontSize: '2.5rem', marginBottom: '10px' }}>👋</h1>
                  <h2 style={{ margin: '0 0 15px 0', fontSize: '1.8rem' }}>{welcomeConfig.welcome_title}</h2>
                  <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>{welcomeConfig.welcome_msg_1}</p>
                  <p style={{ lineHeight: '1.6', color: '#aaa', fontSize: '0.9rem', marginBottom: '30px' }}>{welcomeConfig.welcome_msg_2}</p>
                  <p style={{ lineHeight: '1.6', color: '#aaa', fontSize: '0.9rem', marginBottom: '30px' }}>{welcomeConfig.welcome_msg_3}</p>
                  <button onClick={handleCloseWelcome} style={{ background: 'linear-gradient(45deg, #1e90ff, #2ed573)', border: 'none', padding: '12px 30px', borderRadius: '30px', color: 'white', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', marginBottom: '20px', width: '100%' }}>Get Started</button>
                  <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', color: '#888', fontSize: '0.9rem', cursor: 'pointer' }}>
                      <input type="checkbox" checked={dontShowWelcomeAgain} onChange={(e) => setDontShowWelcomeAgain(e.target.checked)} style={{ accentColor: '#1e90ff', transform: 'scale(1.2)' }}/>
                      Don't show this message again
                  </label>
              </div>
          </div>
      )}

      {/* --- NEW CSS STYLE BLOCK (UPDATED) --- */}
      <style>{`
        /* HOTFIX: Force Dark Mode & Fix White Gaps & Restore Wallpaper */
        :root {
            color-scheme: dark; /* Forces iOS Keyboard to Dark Mode */
        }
        html, body { 
            background-color: #1e1e24 !important; 
            overscroll-behavior: none; /* Prevents "bounce" revealing white background */
        }
        #root {
            background-color: transparent !important; /* Allow wallpaper to show through */
        }
        .background-layer {
            z-index: 0 !important; /* Bring wallpaper in front of body background, but behind content */
        }

        .mobile-footer { display: none; }
        @media (max-width: 1250px) {
            .mobile-footer { display: block; }
        }
      `}</style>

    </div>
  );
}

export default App;
